var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrefilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.682 3.318L3.318 9.682m6.364 0L3.318 3.318",
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor"
  })));
}

export default __webpack_public_path__ + "f753e401163ab99c7a122a63c96ae338.svg";
export { SvgPrefilter as ReactComponent };